import Api from './api'

export default {
   getPdf(formData) {
      return Api().post('/umbraco/surface/api/getPdf', formData, {
         responseType: 'blob'
      });
   }
}


// WEBPACK FOOTER //
// ./src/api/filesExportApi.js